export default __webpack_public_path__ + "static/media/team10.3b14d997.png";